app.apply(app.helpers, {
  isNotNullOrUndifined: function isNotNullOrUndifined(elm) {
    if (elm !== Number && elm !== undefined && elm.length > 0) return true;
    return false;
  },
  dateFormat: function dateFormat(elm) {
    var format = 'dd/mm/yyyy';
    var match = new RegExp(format.replace(/(\w+)\W(\w+)\W(\w+)/, "^\\s*($1)\\W*($2)?\\W*($3)?([0-9]*).*").replace(/d|m|y/g, "\\d"));
    var replace = '$1/$2/$3$4'.replace(/\//g, format.match(/\W/));
    elm.value = elm.value.replace(/(^|\W)(?=\d\W)/g, '$10').replace(match, replace).replace(/(\W)+/g, '$1').replace(/[A-Za-z]/, '');
  },
  inputHasValue: function inputHasValue(elm) {
    if (elm.val().length > 0 && elm.val() !== '') {
      return true;
    } else {
      return false;
    }
  },
  trigger: function trigger(event, params) {
    $('body').trigger(event, params);
  },
  getDateFromDays: function getDateFromDays(days) {
    var date = new Date();
    var newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
    return newDate;
  },
  getMonths: function getMonths(format) {
    var months;
    switch (format) {
      case 'MM':
        months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        break;
      case 'MMMM':
        months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        break;
      default:
        console.error('Helpers(getMonths) : Unknown month format provided.');
    }
    return months;
  },
  getDays: function getDays(format) {
    var days;
    switch (format) {
      case 'DD':
        days = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
        break;
      default:
        console.error('Helpers(getDays) : Unknown month format provided.');
    }
    return days;
  },
  toFixedDown: function toFixedDown(number, digits) {
    var re = new RegExp('(\\d+\\.\\d{' + digits + '})(\\d)');
    var m = number.toString().match(re);
    return m ? parseFloat(m[1]) : number.valueOf();
  },
  _formatNumber: function _formatNumber(n) {
    return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
  detectIE: function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      return true;
    }
    return false;
  },
  throwError: function throwError(xhr, status, error) {
    var errorStatus = xhr.status;
    window.location.href = '/error/' + errorStatus;
  },
  ajaxGet: function ajaxGet(url, requestData, successFunc) {
    return $.ajax({
      type: 'GET',
      url: url,
      cache: false,
      data: requestData,
      success: function success(html) {
        if (majestic.helpers.isFunction(successFunc)) {
          successFunc(html);
        }
      },
      error: function error(xhr, text, exception) {
        console.log('Error with ajax request');
      }
    });
  },
  printPage: function printPage() {
    window.print();
    return false;
  },
  openModal: function openModal(url, type) {
    $.magnificPopup.close();
    if (!this.isNotNullOrUndifined(type)) {
      type = 'inline';
    }
    if (this.isNotNullOrUndifined(url)) {
      var options = $.extend(app.options.modal(), {
        items: {
          type: type,
          src: url
        },
        callbacks: {
          open: function open() {
            var _this = this;
            $.magnificPopup.instance.wrap[0].addEventListener('focus', function () {
              app.initElementListeners($('.modal'));
              $('.mfp-content').attr('id', 'Modal');
              $('[data-modal-close]').on('click', function () {
                $.magnificPopup.close();
              });
              $('[data-modal-close]').keydown(function (e) {
                if (e.keyCode === 32) {
                  $.magnificPopup.close();
                }
              });
            });
          }
        }
      });
      $.magnificPopup.open(options);
    }
  },
  additionalSecurityRedirect: function additionalSecurityRedirect(response) {
    if (response.nextRequestAjax) {
      app.helpers.openModal(window.location.origin + response.redirectUrl, "ajax");
    } else if (!this.isNotNullOrUndifined(response.redirectUrl)) {
      app.helpers.openModal(response);
    } else {
      $.magnificPopup.close();
      $('#PageSpinner').show();
      window.location = window.location.origin + response.redirectUrl;
    }
  },
  /**
   * Improve DatePicker Accessibility
   * Created to help improve the accessibility of the 'pickadate' plugin.
   * https://amsul.ca/pickadate.js/
   * @public
   * @param {param} elm : the datepicker input element.
   */

  improveDatePickerAccessibility: function improveDatePickerAccessibility(elm) {
    var datepicker = elm.pickadate();
    var picker = datepicker.pickadate('picker');
    var close = elm.next('.picker').find('.datepicker--close');
    close.on('keydown', function (e) {
      // Closes an active datepicker if the user tabs backwards to the previous element.
      if (e.which === 9 && !e.shiftKey) {
        picker.close();
      }
    });
    elm.on('keydown', function (e) {
      // Closes an active datepicker if the user tabs beyond the current datepicker element.
      if (e.which === 9 && e.shiftKey) {
        picker.close();
      }

      // Opens the current datepicker popup if the user presses 'Enter' on the input element.
      if (e.which === 13) {
        e.preventDefault();
        picker.open();
      }
    });
  },
  /**
   * Redirect to URL if repsonse is valid
   * Use with Razor form data-ajax-mode="replace" and AjaxFormResponseModel
   * If repsonse has an attribute RedirectUrl and no errors, redirect.
   * Else reinitiate view listeners.
   * @public
   * @param {param} response : data from controller on ajax success
   */

  redirectToUrlIfValid: function redirectToUrlIfValid(response) {
    if (hasValidRedirectUrl()) {
      window.location = response.redirectUrl;
    } else if (!isHtml()) {
      response = {
        hasErrors: true,
        errors: []
      };
      response.errors.push('There was an error processing your payment. Please try again later.'); // TODO: Add translation
      console.error('Unable to complete payment process.');
    }
    function hasValidRedirectUrl() {
      return response !== null && !response.hasErrors && response.redirectUrl !== null && response.redirectUrl !== undefined && response.redirectUrl !== '';
    }
    function isHtml() {
      return response !== null && /<[a-z][\s\S]*>/i.test(response);
    }
    app.initElementListeners(document);
  }
});